<template>
  <v-app>
    <v-fade-transition>
      <router-view />
    </v-fade-transition>

    <NotificationsSnackbar />

    <v-overlay :value="isOverlayVisible">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import NotificationsSnackbar from '@/components/TheNotificationsSnackbar.vue';
import { mapActions } from 'vuex';

export default {
  name: 'App',

  metaInfo: {
    title: 'Bench - Use Machine Learning for dev teams subscription',
    titleTemplate: '%s | Bench - Use Machine Learning for dev teams subscribtion',
  },

  components: {
    NotificationsSnackbar,
  },

  computed: {
    isOverlayVisible() {
      return this.$store.state.general.loading;
    },
  },

  created() {
    this.fetchFeaturesData();
  },

  methods: {
    ...mapActions('features', ['fetchFeaturesData']),
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/global.scss";
</style>
